/* ============================================================
   First-Visit Coin Loader — controller (v2)
   Place in: assets/coin-loader.js

   Reference in theme.liquid <head>:
     <script src="{{ 'coin-loader.js' | asset_url }}" defer></script>

   The decision of WHETHER to show the loader is made by the
   small inline script in theme.liquid <head> (which sets
   .coin-loader-pending on <html> before paint). This file:
     - At ~2667ms: releases the scroll lock so the page is
       interactive the instant the curtains start opening.
     - At ~3600ms: removes the loader DOM entirely.

   Total animation: 3600ms. The CSS curtain reveal begins at
   2667ms (74.08% of total) and finishes at 3300ms.
   ============================================================ */

;(function () {
    "use strict"

    var STORAGE_KEY = "coinLoaderSeen_v1"
    var COIN_SEQUENCE_MS = 2380 // CSS: 12 rapid slots @ 165ms + 400ms Cleopatra hold
    var CURTAIN_RISE_MS = 1100 // CSS: transition duration on .coin-loader__curtain
    var SAFETY_TAIL_MS = 100

    // If the inline head script decided NOT to show the loader,
    // there'll be no .coin-loader-pending class. In that case,
    // make sure any loader markup is removed and bail.
    if (!document.documentElement.classList.contains("coin-loader-pending")) {
        var stray = document.querySelector(".coin-loader")
        if (stray) stray.remove()
        return
    }

    // Belt-and-braces scroll lock: actively block scroll events
    // while the loader is on screen.
    function preventScroll(e) {
        if (e.target && e.target.closest && e.target.closest(".coin-loader")) {
            if (e.type === "wheel" || e.type === "touchmove") e.preventDefault()
            return
        }
        e.preventDefault()
    }

    function preventScrollKeys(e) {
        var blocked = [32, 33, 34, 35, 36, 37, 38, 39, 40]
        if (blocked.indexOf(e.keyCode) !== -1) e.preventDefault()
    }

    var scrollBlockOpts = { passive: false, capture: true }
    window.addEventListener("wheel", preventScroll, scrollBlockOpts)
    window.addEventListener("touchmove", preventScroll, scrollBlockOpts)
    window.addEventListener("keydown", preventScrollKeys, scrollBlockOpts)

    function startReveal() {
        // Body becomes visible NOW (while curtain still covers everything),
        // so when the curtain slides up there's real page content underneath
        // to reveal — not the html element's default background.
        document.documentElement.classList.add("coin-loader-revealing")
    }

    function releaseScrollLock() {
        window.removeEventListener("wheel", preventScroll, scrollBlockOpts)
        window.removeEventListener("touchmove", preventScroll, scrollBlockOpts)
        window.removeEventListener(
            "keydown",
            preventScrollKeys,
            scrollBlockOpts
        )
        // Drop all loader classes; body and html return to normal layout.
        document.documentElement.classList.remove("coin-loader-pending")
        document.documentElement.classList.remove("coin-loader-revealing")
        document.documentElement.classList.remove("coin-loader-playing")
    }

    function removeLoader() {
        var loader = document.querySelector(".coin-loader")
        if (loader && loader.parentNode) {
            loader.parentNode.removeChild(loader)
        }
    }

    function whenReady(cb) {
        if (
            document.readyState === "complete" ||
            document.readyState === "interactive"
        ) {
            cb()
        } else {
            document.addEventListener("DOMContentLoaded", cb)
        }
    }

    whenReady(function () {
        // Mark as seen the moment we commit to showing the animation.
        try {
            localStorage.setItem(STORAGE_KEY, "1")
        } catch (e) {
            /* ignore */
        }

        // Force layout/paint flush, then start everything on the next
        // frame. This ensures the coin animation begins at the same
        // moment we start counting toward the reveal — no drift.
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                // 1. Start the coin sequence.
                document.documentElement.classList.add("coin-loader-playing")

                // 2. After 2400ms (sequence done), trigger the reveal.
                window.setTimeout(startReveal, COIN_SEQUENCE_MS)

                // 3. After reveal completes, clean up.
                var revealComplete =
                    COIN_SEQUENCE_MS + CURTAIN_RISE_MS + SAFETY_TAIL_MS
                window.setTimeout(function () {
                    releaseScrollLock()
                    removeLoader()
                }, revealComplete)
            })
        })
    })
})()
